var React = require('react');

function VideoPlayCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M38.5487 75.9424C59.5038 75.9424 76.4912 58.955 76.4912 38C76.4912 17.0449 59.5038 0.0574951 38.5487 0.0574951C17.5937 0.0574951 0.606262 17.0449 0.606262 38C0.606262 58.955 17.5937 75.9424 38.5487 75.9424ZM52.9408 38.436L29.3903 52.3918V24.4801L52.9408 38.436Z","fill":"white"}));
}

VideoPlayCircle.defaultProps = {"width":"77","height":"76","viewBox":"0 0 77 76","fill":"none"};

module.exports = VideoPlayCircle;

VideoPlayCircle.default = VideoPlayCircle;
